import React from 'react'

import PageBanner from '../components/page-banner'
import InteractiveBanner from '../components/interactive-banner'
import CategoryBanner from '../components/category-banner'
import MachineBanner from '../components/machine-banner'
import Testimonials from '../components/testimonials'
import TabbedComponents from '../components/tabbed-components'
import BrandsShowcase from '../components/brands-showcase'
import CategoryArchive from '../components/category-archive'
import BrandsArchive from '../components/brands-archive'
import MachineArchive from '../components/machine-archive'
import PostsArchive from '../components/posts-archive'
import Timeline from '../components/timeline'
import TeamArchive from '../components/team-archive'
import LatestArticles from '../components/latest-articles'
import Video from '../components/video'
import VideoBlock from '../components/video-block'
import Content from '../components/content'
import Gallery from '../components/gallery'
import ResourcesBlock from '../components/resources-block'
import BrandIntro from '../components/brand-intro'
import TabbedContent from '../components/tabbed-content'
import ShowcaseMixed from '../components/showcase-mixed'
import IconBanner from '../components/icon-banner'
import Breadcrumbs from '../components/breadcrumbs'
import ActiveCampaignComponent from '../components/active-campaign-component'
import InStockMachine from "../components/in-stock-machine"
import ApplicationGallery from "../components/application-gallery"

const renderBlock = (page, el, i, nodeType = null) => {
  if (!nodeType) nodeType = page.nodeType.toLowerCase()
  const param = el?.fieldGroupName?.replace(nodeType, '')
  el.wpPage = page

  let block = {
    '_Acf_ContentBlocks_PageBanner' : (el, i) => <PageBanner key={i} {...el} />,
  	'_Acf_ContentBlocks_InteractiveBanner' : (el, i) => <InteractiveBanner key={i} {...el} />,
  	'_Acf_ContentBlocks_CategoryBanner' : (el, i) => <CategoryBanner key={i} {...el} />,
    '_Acf_ContentBlocks_MachineBanner' : (el, i) => <MachineBanner key={i} {...el} />,
    '_Acf_ContentBlocks_Testimonials' : (el, i) => <Testimonials key={i} {...el} />,
    '_Acf_ContentBlocks_TabbedComponents' : (el, i) => <TabbedComponents key={i} {...el} />,
    '_Acf_ContentBlocks_TabbedContent' : (el, i) => <TabbedContent key={i} {...el} />,
    '_Acf_ContentBlocks_BrandsShowcase' : (el, i) => <BrandsShowcase key={i} {...el} />,
    '_Acf_ContentBlocks_CategoryArchive' : (el, i) => <CategoryArchive key={i} {...el} />,
    '_Acf_ContentBlocks_BrandsArchive' : (el, i) => <BrandsArchive key={i} {...el} />,
    '_Acf_ContentBlocks_MachineArchive' : (el, i) => <MachineArchive key={i} {...el} />,
    '_Acf_ContentBlocks_PostsArchive' : (el, i) => <PostsArchive key={i} {...el} />,
    '_Acf_ContentBlocks_Timeline' : (el, i) => <Timeline key={i} {...el} />,
    '_Acf_ContentBlocks_TeamArchive' : (el, i) => <TeamArchive key={i} {...el} />,
    '_Acf_ContentBlocks_LatestArticles' : (el, i) => <LatestArticles key={i} {...el} />,
    '_Acf_ContentBlocks_Video' : (el, i) => <Video key={i} {...el} />,
    '_Acf_ContentBlocks_ResourcesBlock' : (el, i) => <ResourcesBlock key={i} {...el} />,
    '_Acf_ContentBlocks_VideoBlock' : (el, i) => <VideoBlock key={i} {...el} />,
    '_Acf_ContentBlocks_Content' : (el, i) => <Content key={i} {...el} />,
    '_Acf_ContentBlocks_Gallery' : (el, i) => <Gallery key={i} {...el} />,
    '_Acf_ContentBlocks_BrandIntro' : (el, i) => <BrandIntro key={i} {...el} />,
    '_Acf_ContentBlocks_ExpertsShowcase' : (el, i) => <ShowcaseMixed key={i} {...el} />,
    '_Acf_ContentBlocks_RelatedTopics': (el, i) => <ShowcaseMixed key={i} {...el} />,
    '_Acf_ContentBlocks_IconBanner': (el, i) => <IconBanner key={i} {...el} />,
    '_Acf_ContentBlocks_Breadcrumbs': (el, i) => <Breadcrumbs key={i} {...el} />,
    '_Acf_ContentBlocks_ActiveCampaignForm': (el, i) => <ActiveCampaignComponent key={i} {...el} />,
    '_Acf_ContentBlocks_InStockMachine': (el, i) => <InStockMachine key={i} {...el} />,
    '_Acf_ContentBlocks_ApplicationGallery': (el, i) => <ApplicationGallery key={i} {...el} />
  }[param]

  if (!block) {
    if (process.env.NODE_ENV === 'development') {
      console.log(el)
    }
    return null
  }


  return block(el, i)
}

export default renderBlock